// Media queries extracted from _media-queries.scss
const media = {
  mobileUp: 'min-width: 768px',
  mobileDown: 'max-width: 767px',
  tabletUp: 'min-width: 768px',
  tabletDown: 'max-width: 1024px',
  desktopUp: 'min-width: 1024px',
  desktopDown: 'max-width: 1023px'
}

export default media
